import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-end gap-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-filter" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  role: "group",
  "aria-label": "blah",
  class: "btn-group"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    name: "Monthly",
    id: "btnradioM",
    autocomplete: "off",
    value: "M",
    class: "btn-check"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    for: "btnradioM",
    class: "btn btn-sm btn-pill btn-outline-primary"
  }, "Monthly"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    name: "Yearly",
    id: "btnradioY",
    autocomplete: "off",
    value: "Y",
    class: "btn-check"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    for: "btnradioY",
    class: "btn btn-sm btn-pill btn-outline-primary"
  }, "Yearly")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-with-icon alert-dismissible alert-slim alert-warning my-3 shadow",
    role: "alert"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "alert-icon fal fa-clock fa-lg" }),
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn-close",
      "data-bs-dismiss": "alert",
      "aria-label": "Close"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-2 justify-content-between align-items-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "alert-heading" }, [
          /*#__PURE__*/_createTextVNode("You have "),
          /*#__PURE__*/_createElementVNode("b", null, "X days remaining"),
          /*#__PURE__*/_createTextVNode(" of your free trial. Click to see upgrade options.")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        class: "btn btn-sm btn-outline-primary stretched-link",
        target: "_blank",
        href: "https://loupey.io/pricing"
      }, "Pricing")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-with-icon alert-dismissible alert-slim alert-danger my-3 shadow",
    role: "alert"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "alert-icon fal fa-clock fa-lg" }),
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn-close",
      "data-bs-dismiss": "alert",
      "aria-label": "Close"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-2 justify-content-between align-items-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "alert-heading" }, [
          /*#__PURE__*/_createTextVNode("You have "),
          /*#__PURE__*/_createElementVNode("b", null, "X days remaining"),
          /*#__PURE__*/_createTextVNode(" of your free trial. Click to see upgrade options.")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary alert-fat alert-with-icon alert-dismissible fade show my-3 shadow",
    role: "alert"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "alert-icon fal fa-info-circle fa-lg" }),
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn-close",
      "data-bs-dismiss": "alert",
      "aria-label": "Close"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading flex-grow-1" }, "Hello Louper!"),
        /*#__PURE__*/_createElementVNode("p", null, " Here's an overview of your recent marketing activity and metrics showing the health of your customer base. ")
      ])
    ])
  ])
], -1)
const _hoisted_5 = { class: "container-fluid my-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", {
  id: "overview-tabs",
  class: "nav nav-tabs nav-tabs-primary",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      id: "overview-timing-tab",
      class: "nav-link active",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overview-timing-content",
      role: "tab",
      "aria-controls": "overview-timing-content",
      "aria-selected": "true"
    }, "Timing")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      id: "overview-audience-tab",
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overview-audience-content",
      role: "tab",
      "aria-controls": "overview-audience-content",
      "aria-selected": "false"
    }, "Audience")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      id: "overview-engagement-tab",
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overview-engagement-content",
      role: "tab",
      "aria-controls": "overview-engagement-content",
      "aria-selected": "false"
    }, "Engagement")
  ])
], -1)
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "overview-timing-content",
  role: "tabpanel",
  "aria-labelledby": "overview-timing-tab"
}
const _hoisted_9 = { class: "d-flex flex-column flex-md-row row align-items-stretch my-3" }
const _hoisted_10 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_11 = { class: "card shadow w-100 h-100 p-3" }
const _hoisted_12 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_13 = { class: "card shadow w-100 h-100 p-3" }
const _hoisted_14 = { class: "col-12 mb-3" }
const _hoisted_15 = { class: "card shadow w-100 h-100 p-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  id: "overview-audience-content",
  role: "tabpanel",
  "aria-labelledby": "overview-timing-tab"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  id: "overview-engagement-content",
  role: "tabpanel",
  "aria-labelledby": "overview-timing-tab"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DayTimeImpactChart = _resolveComponent("DayTimeImpactChart")!
  const _component_ResponseTimeChart = _resolveComponent("ResponseTimeChart")!
  const _component_FirstChart = _resolveComponent("FirstChart")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#filter-bar-content" }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
        }, "Filter"),
        _hoisted_3
      ])
    ])),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_DayTimeImpactChart, { parentFilter: _ctx.filterSettings }, null, 8, ["parentFilter"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_ResponseTimeChart, { parentFilter: _ctx.filterSettings }, null, 8, ["parentFilter"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_FirstChart, { parentFilter: _ctx.filterSettings }, null, 8, ["parentFilter"])
              ])
            ])
          ])
        ]),
        _hoisted_16,
        _hoisted_17
      ])
    ])
  ]))
}